<template>
  <div class="newMagazine">
    <navigator :items="items"></navigator>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card">
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-12">
                      <div class="form-group">
                        <label for>
                          Nome
                          <span class="required-field">*</span>
                        </label>
                        <input v-model="magazine.name" type="text" class="form-control" />
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group">
                        <label for>
                          Descrição Resumida
                          <span class="required-field">*</span>
                        </label>
                        <textarea v-model="magazine.description" type="text" class="form-control" />
                      </div>
                    </div>
                    <div class="col-12" v-if="magazine || formType == 'create'">
                      <div class="form-group">
                        <label for>
                          Descrição Detalhada
                          <span class="required-field">*</span>
                        </label>
                        <text-editor-component
                          :textContent="magazine.detailed_description"
                          @updateContentComponent="updateContent"
                        ></text-editor-component>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group">
                        <label for>
                          Detalhes da Publicação
                          <span class="required-field">*</span>
                        </label>
                        <textarea v-model="magazine.details" type="text" class="form-control" />
                      </div>
                    </div>
                    <div
                      class
                      v-bind:class="{'col-lg-6':magazine.cover_path, 'col-lg-9': !magazine.cover_path}"
                    >
                    
                      <div class="form-group">
                        <label for>{{magazine.cover_path ? 'Alterar Capa' : 'Capa'}}
                          <span class="required-field">*</span>
                        </label>
                        <b-form-file
                          placeholder="Escolha uma capa para a revista"
                          drop-placeholder="Arraste o arquivo aqui..."
                          browse-text="Procurar"
                          accept="image/jpeg, image/png, image/jpg"
                          v-on:change="uploadFile"
                        ></b-form-file>
                      </div>
                    </div>
                    <div class="col-lg-3" v-if="magazine.cover_path">
                      <div
                        class="w-100 h-100 d-flex-align-items-center justify-content-end"
                        style="padding-top: 32px;"
                      >
                        <a :href="magazine.cover_url" target="_blank" rel="noopener noreferrer">
                          <button class="btn btn-primary float-right">Ver anexo atual</button>
                        </a>
                      </div>
                    </div>
                     <div class="col-lg-3 col-12">
                      <div class="form-group">
                        <label for>
                          Ordem
                          <span class="required-field">*</span>
                        </label>
                        <input v-model="magazine.order" type="number" class="form-control" />
                      </div>
                    </div>
               
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <button class="btn btn-primary float-right" v-on:click="save()">Salvar</button>
                    </div>
                  </div>
                </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/api/axios";
import TextEditorComponent from "@/components/inputs/TextEditorComponent";
import Multiselect from "vue-multiselect";
import MagazineValidate from "@/imports/validator/models/magazine";
import validator from "@/imports/validator/validate";
import Swal from "sweetalert2";
import { bus } from "@/main";

export default {
  name: "newMagazine",
  props: {
    id: Number
  },
  components: {
    TextEditorComponent,
    Multiselect
  },
  data() {
    return {
      tempFile: "",
      formType: "create",
      magazine: {}, 
      items: [
        {
          text: "Revistas",
          route: "admin.magazines"
        },
        {
          text: "Nova Revista",
          active: true
        }
      ],
    };
  },
  mounted() {
    if(this.id)
      this.getDataObject(this.id);
  },
  methods: {
    getDataObject: function(id) {
      bus.$emit('changeLoading', true);
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/magazines/${id}`)
        .then(response => {
          this.magazine = response.data;
          this.items[1].text = this.magazine.name;
          this.formType = "edit";
          bus.$emit('changeLoading', false);
        });
    },
    updateContent: function(val) {
      this.magazine.detailed_description = val;
    },
    uploadFile: function(e) {
      const file = e.target.files[0];
      if (!file.type.includes("image/") && !file.type.includes("/pdf")) {
        return;
      }
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = event => {
          this.tempFile = event.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    save: function() {
      bus.$emit('changeLoading', true);
      if (this.tempFile != "") {
        this.magazine.image = this.tempFile;
      }
      let errors = validator.validate(this.magazine, MagazineValidate.model);
      
      if (errors.length == 0) {
        let promise =
          this.formType == "create"
            ? axios.post(`${process.env.VUE_APP_API_HOST}/api/magazines`, this.magazine)
            : axios.put(
                `${process.env.VUE_APP_API_HOST}/api/magazines/${this.magazine.id}`,
                this.magazine
              );

        promise
          .then(response => {
            bus.$emit('changeLoading', false);
            Swal.fire({
              title:
                this.formType == "create"
                  ? "Revista cadastrada"
                  : "Revista alterada com sucesso",
              icon: "success",
              onClose: () => {
                this.$router.push({ name: "admin.magazines" });
              }
            });
          })
          .catch(error => {
            bus.$emit('changeLoading', false);
            Swal.fire({
              title: "Ocorreu um erro.",
              icon: "error"
            });
          });
      } else {
        bus.$emit('changeLoading', false);
        let html = "Preencha todos os campos obrigatórios.";
        if (errors.length < 4) {
          html = "";
          errors.forEach(el => (html += el.message + "<br>"));
        }
        Swal.fire({
          title: "Atenção",
          html: html,
          icon: "warning"
        });
      }
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/General.scss";

.newMagazine {
  .toggle-input {
    height: 37px;
    label {
      margin-bottom: 0 !important;
      margin-left: 5px;
    }
  }
  .card-header {
    background-color: white;
    a {
      text-decoration: none;
      color: $red_primary;
    }
  }
  .text-content{
    margin-top: 15px
  }
  .text-indice{
    background-color: $red_primary;
    width: fit-content;
    color: white;
    padding: 3px 10px;
    margin-bottom: 15px;
  }
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
